var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 35H15V15H21.6667V18.3333C23.0877 16.5254 25.2427 15.4476 27.5417 15.395C31.676 15.418 35.012 18.7823 35 22.9167V35H28.3333V23.75C28.0667 21.8877 26.4696 20.506 24.5883 20.51C23.7655 20.536 22.9887 20.8963 22.4374 21.5077C21.8861 22.1191 21.6077 22.9288 21.6667 23.75V35ZM11.6667 35H5V15H11.6667V35ZM8.33333 11.6667C6.49238 11.6667 5 10.1743 5 8.33333C5 6.49238 6.49238 5 8.33333 5C10.1743 5 11.6667 6.49238 11.6667 8.33333C11.6667 9.21739 11.3155 10.0652 10.6904 10.6904C10.0652 11.3155 9.21739 11.6667 8.33333 11.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.9d8d40f7f58fdd86c2f2e0a16c13e009.svg";
export { ForwardRef as ReactComponent };